/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { UserAccountSummary } from "./UserAccountSummary";
import {
    UserAccountSummaryFromJSON,
    UserAccountSummaryFromJSONTyped,
    UserAccountSummaryToJSON,
} from "./UserAccountSummary";
import type { VehicleSummary } from "./VehicleSummary";
import {
    VehicleSummaryFromJSON,
    VehicleSummaryFromJSONTyped,
    VehicleSummaryToJSON,
} from "./VehicleSummary";
import type { DeviceOwnerDto } from "./DeviceOwnerDto";
import {
    DeviceOwnerDtoFromJSON,
    DeviceOwnerDtoFromJSONTyped,
    DeviceOwnerDtoToJSON,
} from "./DeviceOwnerDto";

/**
 *
 * @export
 * @interface RfidTagDto
 */
export interface RfidTagDto {
    /**
     * The primary key
     * @type {number}
     * @memberof RfidTagDto
     */
    rfidTagId?: number;
    /**
     * The tag id. Unique.
     * @type {string}
     * @memberof RfidTagDto
     */
    id?: string;
    /**
     *
     * @type {string}
     * @memberof RfidTagDto
     */
    status?: RfidTagDtoStatusEnum;
    /**
     *
     * @type {string}
     * @memberof RfidTagDto
     */
    label?: string;
    /**
     * Set for Rule=UserAccount
     * @type {number}
     * @memberof RfidTagDto
     */
    userAccountId?: number;
    /**
     * Set for Rule=DeviceOwner
     * @type {number}
     * @memberof RfidTagDto
     */
    deviceOwnerId?: number;
    /**
     *
     * @type {Date}
     * @memberof RfidTagDto
     */
    createdAt?: Date;
    /**
     *
     * @type {Date}
     * @memberof RfidTagDto
     */
    updatedAt?: Date;
    /**
     *
     * @type {string}
     * @memberof RfidTagDto
     */
    rule?: RfidTagDtoRuleEnum;
    /**
     * The owner of this RfidTag.
     * @type {string}
     * @memberof RfidTagDto
     */
    organisationId?: string;
    /**
     *
     * @type {UserAccountSummary}
     * @memberof RfidTagDto
     */
    userAccount?: UserAccountSummary;
    /**
     *
     * @type {DeviceOwnerDto}
     * @memberof RfidTagDto
     */
    deviceOwner?: DeviceOwnerDto;
    /**
     * Do not set when calling InsertUpdateRfidTag
     * @type {Array<string>}
     * @memberof RfidTagDto
     */
    deviceGroupTags?: Array<string>;
    /**
     *
     * @type {VehicleSummary}
     * @memberof RfidTagDto
     */
    vehicle?: VehicleSummary;
}

/**
 * @export
 */
export const RfidTagDtoStatusEnum = {
    Active: "Active",
    Suspended: "Suspended",
    Archived: "Archived",
} as const;
export type RfidTagDtoStatusEnum =
    (typeof RfidTagDtoStatusEnum)[keyof typeof RfidTagDtoStatusEnum];

/**
 * @export
 */
export const RfidTagDtoRuleEnum = {
    Unknown: "Unknown",
    DeviceOwner: "DeviceOwner",
    DeviceGroups: "DeviceGroups",
    UserAccount: "UserAccount",
} as const;
export type RfidTagDtoRuleEnum =
    (typeof RfidTagDtoRuleEnum)[keyof typeof RfidTagDtoRuleEnum];

/**
 * Check if a given object implements the RfidTagDto interface.
 */
export function instanceOfRfidTagDto(value: object): value is RfidTagDto {
    return true;
}

export function RfidTagDtoFromJSON(json: any): RfidTagDto {
    return RfidTagDtoFromJSONTyped(json, false);
}

export function RfidTagDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): RfidTagDto {
    if (json == null) {
        return json;
    }
    return {
        rfidTagId: json["rfidTagId"] == null ? undefined : json["rfidTagId"],
        id: json["id"] == null ? undefined : json["id"],
        status: json["status"] == null ? undefined : json["status"],
        label: json["label"] == null ? undefined : json["label"],
        userAccountId:
            json["userAccountId"] == null ? undefined : json["userAccountId"],
        deviceOwnerId:
            json["deviceOwnerId"] == null ? undefined : json["deviceOwnerId"],
        createdAt:
            json["createdAt"] == null ? undefined : new Date(json["createdAt"]),
        updatedAt:
            json["updatedAt"] == null ? undefined : new Date(json["updatedAt"]),
        rule: json["rule"] == null ? undefined : json["rule"],
        organisationId:
            json["organisationId"] == null ? undefined : json["organisationId"],
        userAccount:
            json["userAccount"] == null
                ? undefined
                : UserAccountSummaryFromJSON(json["userAccount"]),
        deviceOwner:
            json["deviceOwner"] == null
                ? undefined
                : DeviceOwnerDtoFromJSON(json["deviceOwner"]),
        deviceGroupTags:
            json["deviceGroupTags"] == null
                ? undefined
                : json["deviceGroupTags"],
        vehicle:
            json["vehicle"] == null
                ? undefined
                : VehicleSummaryFromJSON(json["vehicle"]),
    };
}

export function RfidTagDtoToJSON(value?: RfidTagDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        rfidTagId: value["rfidTagId"],
        id: value["id"],
        status: value["status"],
        label: value["label"],
        userAccountId: value["userAccountId"],
        deviceOwnerId: value["deviceOwnerId"],
        createdAt:
            value["createdAt"] == null
                ? undefined
                : value["createdAt"].toISOString(),
        updatedAt:
            value["updatedAt"] == null
                ? undefined
                : value["updatedAt"].toISOString(),
        rule: value["rule"],
        organisationId: value["organisationId"],
        userAccount: UserAccountSummaryToJSON(value["userAccount"]),
        deviceOwner: DeviceOwnerDtoToJSON(value["deviceOwner"]),
        deviceGroupTags: value["deviceGroupTags"],
        vehicle: VehicleSummaryToJSON(value["vehicle"]),
    };
}
